import {
  BankIcon,
  BookmarkIcon,
  CalendarIcon,
  CirclePlusIcon,
  CopyIcon,
  CalendarKycIcon,
  CheckIcon,  
  CloseIcon,  
  DictionaryIcon,
  EditIcon,
  EyeCloseIcon,
  EyeOpenIcon,
  FilterIcon,
  HomeFilledIcon,
  HomeIcon,
  InformationIcon,
  LegalIcon,
  LiveIcon,
  LockClosedIcon,
  LockOpenIcon,
  MailIcon,
  MoneyIcon,
  ProfileIcon,
  ReferralIcon,
  ReloadIcon,
  RewardIcon,
  RupiahIcon,
  SearchIcon,
  SettlementIcon,
  StarIcon,
  TargetIcon,
  TimeBreakIcon,
  TimeRewindIcon,
  TransactionIcon,
  TriangleDownIcon,
  TriangleUpIcon,
  TrendingIcon,
  WithdrawIcon,
} from './icons';

const ICON_LIST = {
  calendarKyc: CalendarKycIcon,
  check: CheckIcon,
  close: CloseIcon,  
  'eye-close': EyeCloseIcon,
  'eye-open': EyeOpenIcon,
  bank: BankIcon,
  bookmark: BookmarkIcon,
  calendar: CalendarIcon,
  'circle-plus': CirclePlusIcon,
  copy: CopyIcon,
  dictionary: DictionaryIcon,
  edit: EditIcon,
  filter: FilterIcon,
  'home-filled': HomeFilledIcon,
  home: HomeIcon,
  information: InformationIcon,
  legal: LegalIcon,
  live: LiveIcon,
  'lock-closed': LockClosedIcon,
  'lock-open': LockOpenIcon,
  mail: MailIcon,
  money: MoneyIcon,
  profile: ProfileIcon,
  referral: ReferralIcon,
  reload: ReloadIcon,
  reward: RewardIcon,
  rupiah: RupiahIcon,
  search: SearchIcon,
  settlement: SettlementIcon,
  star: StarIcon,
  target: TargetIcon,
  'time-break': TimeBreakIcon,
  'time-rewind': TimeRewindIcon,
  transaction: TransactionIcon,
  trending: TrendingIcon,
  'triangle-down': TriangleDownIcon,
  'triangle-up': TriangleUpIcon,
  withdraw: WithdrawIcon,
};

export default ICON_LIST;
